import React from 'react';
import { Row, Col } from 'react-bootstrap';

function PrintView(props) {

    const reqTotalReceivable = ((props.rhdata.req_sellrate * props.rhdata.req_quantity).toFixed(2) * 1 + props.rhdata.req_tcs * 1 + props.rhdata.req_gst * 1 + props.rhdata.req_bankcharges * 1 + props.rhdata.req_nostrocharges * 1).toFixed();


    return (
        <>

            <Row  >
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className='border-top' >
                <Col>Reference Number : <b>{props.rhdata.req_refno}</b></Col>
                <Col>Branch : <b>{props.rhdata.req_brnno + ' : ' + props.rhdata.req_brnnm}</b></Col>
                <Col>Reference : <b>{props.rhdata.req_type === "S" ? "Branch" : "Agent"}</b></Col>
                <Col>Agent : {
                    props.rhdata.req_agentno * 1 === 0 ? null : <>
                        <b>{props.rhdata.req_agentno + ' : ' + props.rhdata.req_agentnm + ' ' + props.rhdata.mel_location}</b>
                    </>
                }
                </Col>
            </Row>
            {
                props.rhdata.req_bankrefno === "" ?
                    <></> : <>
                        <Row>
                            <Col>
                                Bank Reference : <b>{props.rhdata.req_bankrefno}</b>
                            </Col>
                            <Col>AD2 Reference : <b>{props.rhdata.req_ad2ref}</b></Col>
                            <Col>&nbsp;</Col>
                            <Col>&nbsp;</Col>
                        </Row>
                    </>
            }

            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row>
                <Col>Remitter Type : <b>{props.rhdata.req_remittertype === "I" ? "Individual" : "Corporate"}</b></Col>
                <Col>Remitter Name : <b>{props.rhdata.req_remittername}</b></Col>
                <Col>PAN : <b>{props.rhdata.mpr_rel_name} : {props.rhdata.req_pan}</b></Col>
                <Col>Name on Pan : <b>{props.rhdata.req_nameonpan}</b></Col>
            </Row>
            {
                props.rhdata.nsdl_response === "" ? <></> : <>
                    <Row>
                        <Col>
                            PAN Verified By <b>Zenith Leisure Holidays Limited</b> : Yes
                            &nbsp;Date : {props.rhdata.nsdl_datedmy}

                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            &nbsp; Response : {props.rhdata.nsdl_response}
                        </Col>
                    </Row>
                </>
            }
            <Row >
                <Col>
                    &nbsp;
                </Col>
            </Row >
            <Row >
                <Col>Purpose: <b>{props.rhdata.req_purpose + ' : ' + props.rhdata.req_purposenm}</b></Col>
                <Col>Additional : <b>{props.rhdata.pursub_name}</b></Col>
                <Col>Serial Number : <b>{props.rhdata.req_srno}</b></Col>
                <Col>Product : <b>{props.rhdata.req_productcode}</b></Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row >
                <Col>Currency: <b>{props.rhdata.req_isd} ({props.rhdata.req_tenure})</b></Col>
                <Col>Quantity: <b>{props.rhdata.req_quantity}</b></Col>
                <Col>Sell Rate: <b>{props.rhdata.req_sellrate}</b></Col>
                <Col>Forex INR : <b>{(props.rhdata.req_sellrate * props.rhdata.req_quantity).toFixed(2)}</b> </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>

            <Row >
                <Col>Email : <b>{props.rhdata.req_email}</b></Col>
                <Col>Mobile : <b>{props.rhdata.req_mobile}</b></Col>
                <Col>Nostro Type : <b>{props.rhdata.req_nostrotype}</b></Col>
                <Col>BANK : {
                    props.rhdata.req_bank * 1 === 0 ? null :
                        <>
                            <b>{props.rhdata.req_bank + ' : ' + props.rhdata.req_banknm}</b>
                        </>
                }
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>ITR 2 Years: <b>{props.rhdata.req_itr2year === 1 ? "Yes" : "No"}</b></Col>
                <Col>Source of Fund: <b>{props.rhdata.req_sourceoffund === "S" ? "Self" : "Loan"}</b></Col>
                {
                    props.rhdata.req_sourceoffund === "L" ? <>
                        <Col>Disbursed Institute: <b>{props.rhdata.req_disbinstname}</b></Col>
                        <Col>Disbursed Amount: <b>{props.rhdata.req_disbamount}</b></Col>
                    </> : <>
                        <Col>&nbsp;</Col><Col>&nbsp;</Col>
                    </>
                }
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk}</b></Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk1}</b></Col>
            </Row>
            <Row>
                <Col xs={12}>Remark: <b>{props.rhdata.req_rmk2}</b></Col>
            </Row>
            <Row className='border-bottom'>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <h5>Loan Related Details</h5>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Loan Account No : <b>{props.rhdata.req_loanaccountno}</b></Col>
                <Col>Loan Applicant : <b>{props.rhdata.req_loanapplicant}</b></Col>
                <Col>Loan Applicant Passport : <b>{props.rhdata.req_loanapplicantpassport}</b></Col>
                <Col>Loan Applicant Pan : <b>{props.rhdata.req_loanapplicantpan}</b></Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Loan Co Applicant : <b>{props.rhdata.req_loancoapplicant}</b></Col>
                <Col>Loan Co App Passport : <b>{props.rhdata.req_loancoapplicantpassport}</b></Col>
                <Col>Loan Co App Pan : <b>{props.rhdata.req_loancoapplicantpan}</b></Col>
                <Col>&nbsp;</Col>
            </Row>
            <Row className='border-bottom'>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    <h5>Remitter Details</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Remitter Type : <b>{props.rhdata.req_remittertype === "C" ? "Entity" : "Individual"}</b></Col>
                <Col>Remitter Name : <b>{props.rhdata.req_remittername}</b></Col>

                <Col xs={6} >Remitter Address : <b>{props.rhdata.req_remitteraddress}</b></Col>

                {
                    /*
                        <Col>Date Of Birth : <b>{String(props.rhdata.req_remitterdob).split('-').reverse().join('/')}</b></Col>
                    */
                }
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>ID Type : <b>{props.rhdata.req_remitteridtype}</b></Col>
                <Col>ID Number : <b>{props.rhdata.req_remitteridno}</b></Col>
                <Col>
                    &nbsp;
                </Col>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className='border-bottom'>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    <h5>Beneficiary Details</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Beneficiary Type : <b>{props.rhdata.req_benetype === "C" ? "Entity" : "Individual"}</b></Col>
                <Col>Beneficiary Name : <b>{props.rhdata.req_benename}</b></Col>
                <Col xs={6}>Beneficiary Address : <b>{props.rhdata.req_beneadd}</b></Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Beneficiary Country :<b>{props.rhdata.req_benecountrynm}</b></Col>
                <Col>Beneficiary City : <b>{props.rhdata.req_benecity}</b> </Col>
                <Col>&nbsp;</Col>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Beneficiary Bank : <b>{props.rhdata.req_benebank}</b></Col>
                <Col>Beneficiary Account No: <b>{props.rhdata.req_benebankacct}</b></Col>
                <Col>Swift Code : <b>{props.rhdata.req_beneswiftcode}</b></Col>
                <Col >Beneficiary Bank Address: <b>{props.rhdata.req_benebankadd}</b></Col>
            </Row>
            <Row>
                <Col>&nbsp;</Col>
            </Row>
            <Row>
                <Col>
                    Beneficiary Bank Country: <b>{props.rhdata.req_benebankcountryname}</b>
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Routing No.(For USD) : <b>{props.rhdata.req_beneroutingno}</b></Col>
                <Col>Sort Code (For GBP) : <b>{props.rhdata.req_benesortcode}</b></Col>
                <Col>BSB No.(For AUD) : <b>{props.rhdata.req_benebsbno}</b></Col>
                <Col>Transit No.(For CAD) : <b>{props.rhdata.req_benetransitno}</b></Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Other Details : <b>{props.rhdata.req_otherdetail}</b></Col>
            </Row>
            <Row>
                <Col>Student/University (not printed on swift) : <b>{props.rhdata.req_studentdetail}</b></Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row className='border-bottom'>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>
                    <h5>Correspondent Bank Details</h5>
                </Col>
            </Row>
            <Row>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>Bank Name : <b>{props.rhdata.req_corresbankname}</b></Col>
                <Col>Swift Code : <b>{props.rhdata.req_corresbankacctno}</b></Col>

                <Col>Bank Address : <b>{props.rhdata.req_corresbankadd}</b></Col>
                <Col>Bank Country : <b>{props.rhdata.req_corresbankcountryname}</b></Col>
            </Row>
            <Row className='border-bottom'>
                <Col>
                    &nbsp;
                </Col>
            </Row>
            <Row>
                <Col>
                    Forex : {(props.rhdata.req_sellrate * props.rhdata.req_quantity).toFixed(2)}&nbsp;&nbsp;&nbsp;
                    TCS : {props.rhdata.req_tcs}&nbsp;&nbsp;&nbsp;
                    GST : {props.rhdata.req_gst}&nbsp;&nbsp;&nbsp;
                    Bank Charges : {props.rhdata.req_bankcharges}&nbsp;&nbsp;&nbsp;
                    Nostro : {props.rhdata.req_nostrocharges}&nbsp;&nbsp;&nbsp;
                    Total : <b>{reqTotalReceivable}</b>
                </Col>
            </Row>
            <Row className='border-top'>
                <Col>
                    &nbsp;
                </Col>
            </Row >

            <Row>
                <Col>&nbsp;</Col>
            </Row>
        </>
    )
}
export default PrintView;